import { useEffect, useState } from "react";
import { Trophy, MapPin } from "@phosphor-icons/react";
import api from "@/lib/api";

export function LocationInsight({ refreshKey }) {
  const [rows, setRows] = useState([]);
  useEffect(() => {
    api.get("/market/business/promotions/locations").then(({ data }) => setRows(data)).catch(() => setRows([]));
  }, [refreshKey]);

  const max = Math.max(1, ...rows.map((r) => r.views));
  return (
    <div className="space-y-2" data-testid="location-insight">
      <p className="text-xs font-bold text-sky-800 uppercase tracking-wider flex items-center gap-1"><MapPin size={14} weight="fill" /> Best locations</p>
      {rows.length === 0 && <p className="text-sm text-sky-700/70">No location results yet — they appear once people see your promoted card.</p>}
      {rows[0] && (
        <div className="rounded-2xl bg-gradient-to-r from-sky-400 to-cyan-300 text-white p-4 flex items-center gap-3" data-testid="location-insight-best">
          <Trophy size={32} weight="fill" className="text-yellow-200 shrink-0" />
          <div>
            <p className="text-xs font-bold uppercase tracking-wider text-white/85">Top location</p>
            <p className="font-heading text-xl font-black leading-tight">{rows[0].location}</p>
            <p className="text-sm text-white/90">{rows[0].views} saw it · {rows[0].taps} tapped</p>
          </div>
        </div>
      )}
      {rows.map((r, i) => (
        <div key={r.location} className="space-y-1" data-testid={`location-insight-row-${i}`}>
          <div className="flex justify-between text-sm">
            <span className="text-sky-900 font-semibold">{r.location}</span>
            <span className="text-sky-700">{r.views} saw · {r.taps} tapped</span>
          </div>
          <div className="h-2 rounded-full bg-sky-50 overflow-hidden">
            <div className="h-full rounded-full bg-sky-400 transition-[width] duration-700" style={{ width: `${(r.views / max) * 100}%` }} />
          </div>
        </div>
      ))}
    </div>
  );
}
